import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RInboxKey = t.type({
  id: t.number,
  updatedAt: t.number,
});

export const RTeammateInboxesUpdate = t.readonly(
  t.type({
    teammateId: t.number,
    addedToInboxes: t.readonlyArray(RInboxKey),
    removedFromInboxes: t.readonlyArray(RInboxKey),
  }),
  'teammateInboxesUpdate',
);

/*
 * Type.
 */

interface InboxKey extends t.TypeOf<typeof RInboxKey> {}
export interface TeammateInboxesUpdate extends t.TypeOf<typeof RTeammateInboxesUpdate> {}

/*
 * IO methods.
 */

export function parseTeammateInboxesUpdate(src: any): TeammateInboxesUpdate {
  return {
    teammateId: src.teammate_id,
    addedToInboxes: (src.inboxes_added || []).map(parseInboxKey),
    removedFromInboxes: (src.inboxes_removed || []).map(parseInboxKey),
  };
}

function parseInboxKey(src: any): InboxKey {
  return {
    id: src.id,
    updatedAt: src.updated_at,
  };
}

/*
 * API type.
 */

export const ApiTeammateInboxesUpdate = makeApiType(
  'teammateInboxesUpdate',
  RTeammateInboxesUpdate,
  parseTeammateInboxesUpdate,
);
